import { render } from "./ICMMenuTitle.vue?vue&type=template&id=028b1cfa&scoped=true"
const script = {}

import "./ICMMenuTitle.vue?vue&type=style&index=0&id=028b1cfa&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028b1cfa"]])

export default __exports__